export default class ConfigurationRepoStatic {
  getConfigurationsForShip(ship, service) {
    service.addNewConfigurationFromRepo(ship, ship.id + "_1", {
      name: "base",
      description: "descripción configuración base",
      attainedEEXI: 7.2,
    });
    service.addNewConfigurationFromRepo(ship, ship.id + "_2", {
      name: "prueba conf2",
      description: "descripción configuración 2",
      attainedEEXI: 12,
    });
  }
}
